export default "__VITE_ASSET__MrFcssHi__"